<template>
    <div>
        <app-form 
            v-bind:parentObject = "{
                // data: this.formData,
                pageTitle: this.pageTitle,
                pageTitleValue: this.pageTitleValue,
                errMsg: this.errMsg,
                isEdit: this.editMode
            }"
            v-on:error="errorHandler"
        />
        <div v-if="isErr">
            <!-- <app-error 
                v-bind:parentError ="{
                    data: this.errMsg,
                    isErr: this.isErr
                }"
            /> -->
            <app-error
                v-bind:parentError="{
                    data: this.errMsg,
                    isErr: this.isErr,
                }"
                v-on:closeError="isErr = $event"
            />
        </div>
    </div>
</template>

<script>
//import CP22ListForm from '../../../components/payroll/cp22/Form_Parameter';
import CP22ListForm from '../../../components/payroll/cp22/Form_ParameterNew';
import ErrorDialog from '../../../components/common/ErrorDialog';
//import moment from 'moment';


export default {
    components: {
        'app-form': CP22ListForm,
        'app-error': ErrorDialog
    },

    data() {
        return{
            pageTitle: this.$t('cpforms.cpforms'),
            pageTitleValue: '',
            
            formData: {
                // payoutcode: null,
                // pyyear: moment().year(),
                // pymonth: null,
                // compnyid: null,
                // total: 0,
            },
            

            // dataItems:[],

            // goBtn: false,

            // yearList: [],
            // monthList: [],
            // payoutcodeList: [],
            // compnycodeList: [],
            // payitemcodeList: [],           

            errMsg: '',
            isErr:false,
            editMode: false 
        }
    },
        

    methods: {
        errorHandler($event) {
            this.isErr = $event.isErr;
            this.errMsg = $event.errMsg;
        },
        
    }
}
</script>